import React from "react"
import { Box, css, Flex, Text, useTheme } from "@chakra-ui/react"
import colors from "@constants/colors"
import { PortableText } from "@utils/sanity"
import { bp } from "@utils/MediaQueries"

export interface JobListingProps {
  location: string
  position: string
  description: any
}

const JobListing: React.FC<JobListingProps> = ({
  location,
  position,
  description,
}) => {
  const theme = useTheme()
  const styles = css({
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Avenir",
    color: "midAccessible",
    width: bp("100%", null, "calc(8.5/16*100vw)"),
    margin: "0 auto",
    paddingX: bp("1rem", null, "0"),

    header: {
      fontSize: bp("33px", null, "48px"),
      fontWeight: "800",
    },
    p: {
      justifySelf: "center",
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      letterSpacing: "0em",
      lineHeight: "22px",
      color: colors.midAccessible,
    },
    h1: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      marginBottom: "24px",
      letterSpacing: "0em",
      lineHeight: "60px",
      fontFamily: "Avenir",
      fontSize: bp("33px", null, "48px"),
      fontStyle: "normal",
      fontWeight: "800",
      color: colors.dark,
    },
    h2: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      color: colors.dark,
      fontSize: bp("27px", null, "40px"),
      fontWeight: bp("700", null, "800"),
    },
    h3: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      fontSize: bp("21px", "33px"),
      fontWeight: bp("700", null, "800"),
      color: colors.dark,
    },
    h4: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      fontSize: bp("16px", "19px"),
      fontWeight: bp("700", null, "800"),
      color: colors.dark,
    },
    h5: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      fontSize: bp("16px", "19px"),
      fontWeight: bp("700", null, "800"),
      color: colors.dark,
    },
    h6: {
      width: bp("100%", null, "100%"),
      minHeight: "1rem",
      fontFamily: "Avenir",
      fontSize: bp("16px", "19px"),
      fontWeight: bp("700", null, "800"),
      color: colors.dark,
    },
    ul: {
      justifySelf: "center",
      width: bp("100%", null, "100%"),
      padding: "1rem 0 1rem 2rem",
    },
    li: {
      fontFamily: "Avenir",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "400",
      letterSpacing: "0em",
      lineHeight: "22px",
      color: colors.midAccessible,
    },
    button: {
      bg: "#000",
      color: "#FFF",
      height: bp("52px", null, "58px"),
      px: "32px",
      rounded: "lg",
      fontSize: bp("13.5px", null, "16px"),
      fontWeight: "800",
    },
    "a:hover": {
      borderBottom: `1px solid ${colors.brand}`,
    },
    a: {
      color: colors.brand,
    },
  })(theme)

  return (
    <Flex css={styles}>
      <Box
        w="100%"
        paddingY={"3.5rem"}
        borderTop={`1px solid ${colors.midLight}`}
      >
        <Box>
          <Text as="h4">{position}</Text>
          <Text>{location}</Text>
        </Box>
        <Box paddingTop="1.25rem">
          <Text as="h6">Job Description:</Text>
          {description && <PortableText blocks={description} />}
        </Box>
      </Box>
    </Flex>
  )
}

export default JobListing
